
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageSquare, RefreshCw } from "lucide-react";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { useReviewsManagement } from "@/hooks/useReviewsManagement";
import { ReviewsTable } from "@/components/admin/reviews/ReviewsTable";
import { ReviewsFilters } from "@/components/admin/reviews/ReviewsFilters";
import { ReviewDetailDialog } from "@/components/admin/reviews/ReviewDetailDialog";
import { ReviewsPagination } from "@/components/admin/reviews/ReviewsPagination";

const ManageReviews = () => {
  const {
    isLoading,
    reviews,
    isDetailOpen,
    setIsDetailOpen,
    selectedReview,
    currentPage,
    setCurrentPage,
    searchTerm,
    setSearchTerm,
    filterRating,
    setFilterRating,
    isRefreshing,
    sortColumn,
    sortDirection,
    totalPages,
    handleRefresh,
    handleViewDetails,
    handleHighlightToggle,
    handleSort,
    renderSortIndicator,
    deleteReviewMutation,
  } = useReviewsManagement();

  return (
    <AdminLayout title="Reviews">
      <div className="space-y-6">
        <Card>
          <CardHeader className="pb-3">
            <div className="flex justify-between items-center">
              <div>
                <CardTitle className="text-xl flex items-center gap-2">
                  <MessageSquare className="h-5 w-5" />
                  Customer Feedback
                </CardTitle>
                <CardDescription>
                  Manage and monitor customer reviews across your services
                </CardDescription>
              </div>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={handleRefresh}
                disabled={isRefreshing}
              >
                <RefreshCw className={`h-4 w-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
                Refresh
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            <ReviewsFilters 
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              filterRating={filterRating}
              onFilterChange={setFilterRating}
            />

            <ReviewsTable 
              isLoading={isLoading}
              reviews={reviews}
              onDelete={(id) => deleteReviewMutation.mutate(id)}
              onViewDetails={handleViewDetails}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              handleSort={handleSort}
              renderSortIndicator={renderSortIndicator}
            />

            <ReviewsPagination 
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </CardContent>
        </Card>
      </div>

      <ReviewDetailDialog 
        isOpen={isDetailOpen}
        onOpenChange={setIsDetailOpen}
        selectedReview={selectedReview}
        onHighlightToggle={handleHighlightToggle}
        onDelete={(id) => deleteReviewMutation.mutate(id)}
      />
    </AdminLayout>
  );
};

export default ManageReviews;
